// extracted by mini-css-extract-plugin
export default {"login":"Login_login__4rE5+","control":"Login_control__n8h81","invalid":"Login_invalid__pl-EE","actions":"Login_actions__DiCLF","btn":"Login_btn__OU5lO"};